import type { RuleName, RuleTraceEntry } from './types';

export class Tracer {
  private entries: RuleTraceEntry[] = [];

  log(entry: RuleTraceEntry): void {
    this.entries.push(entry);
  }

  emit(rule: RuleName, decision: string, reason: string, input?: Record<string, unknown>): void {
    const entry: RuleTraceEntry = input !== undefined
      ? { rule, decision, reason, input }
      : { rule, decision, reason };
    this.entries.push(entry);
  }

  snapshot(): RuleTraceEntry[] {
    return this.entries.slice();
  }
}
